const faqListArr = {
  1: {
    ques:
      'What is the cost of creating a matrimonial profile on BengaliShaadi.com?',
    showCostWrapper: true,
    showLink: true,
    ans: [
      'Registration is absolutely free. To enjoy additional benefits, you can choose any of the below premium membership plans. To know more about these plans,',
    ],
    ansUlLi: [],
  },
  2: {
    ques: 'What is a Profile ID? How is it relevant?',
    showCostWrapper: false,
    showLink: false,
    ans: [
      'Your Profile ID is automatically generated once you register on BengaliShaadi.com. Every Member has a unique Profile ID and Members can find your Profile using the Profile ID search feature.',
    ],
    ansUlLi: [],
  },
  3: {
    ques: 'What are the safety measures on BengaliShaadi.com?',
    showCostWrapper: false,
    showLink: false,
    ans: [
      'We are committed to your safety & privacy and have taken the below measures to bring you a safe matchmaking experience:',
    ],
    ansUlLi: [
      {
        ul: 'Privacy settings',
        li: [
          {
            bold: 'Photo privacy',
            li: ' allows you to control who can view your photos',
          },
          {
            bold: 'Display Name',
            li: ' settings let you maintain anonymity at all times',
          },
          {
            bold: 'Phone number',
            li: ' settings let you decide who can see your number',
          },
        ],
        anchortag: '',
      },
      {
        ul:
          'Profile Screening: Every profile on BengaliShaadi.com is screened to make your experience safe and secure. In the rare case that you come across some misuse on the platform, simply select the ‘Report’ option on the top right of the suspicious profile. Alternatively you can write to us at help@shaadi.com',
        li: [],
        anchortag: 'help@shaadi.com',
        href: 'mailto:someone@example.com',
      },
      {
        ul:
          'Shaadi Chat allows you to have conversations with your matches without sharing your phone number',
        li: [],
        anchortag: '',
      },
    ],
  },
  4: {
    ques: 'What are the steps to register myself on BengaliShaadi.com?',
    showCostWrapper: false,
    showLink: false,
    ans: [],
    ansUlLi: [
      {
        ul: 'Go to www.bengalishaadi.com or download the BengaliShaadi.com app',
        li: [],
        anchortag: 'www.bengalishaadi.com',
        href: 'https://www.bengalishaadi.com',
      },
      {
        ul:
          "Fill out the required information in the Registration Form and click on the 'Submit' button. The more information you provide about yourself, the more likely you are to be contacted by other Members of BengaliShaadi.com. So please do take the time and effort to complete your Profile",
        li: [],
        anchortag: '',
      },
    ],
  },
  5: {
    ques: 'How do I view my matrimony profile on BengaliShaadi.com?',
    showCostWrapper: false,
    showLink: false,
    ans: [
      'Login using your Email ID and Password. Click on ‘My Profile’ to see your profile as others see it.',
    ],
    ansUlLi: [],
  },
  6: {
    ques:
      'Can I specify more than one email while registering on BengaliShaadi.com?',
    showCostWrapper: false,
    showLink: false,
    ans: [
      'No. You may specify only one email while registering. You can however change your email address later if you wish.',
    ],
    ansUlLi: [],
  },
  7: {
    ques:
      'Can I create a matrimony profile on behalf of a relative or a friend?',
    showCostWrapper: false,
    showLink: false,
    ans: [
      'Yes you can! In the registration form, you can specify your relationship with the person on whose behalf you are registering.',
    ],
    ansUlLi: [],
  },
  8: {
    ques: 'What are the benefits of registering on BengaliShaadi.com?',
    showCostWrapper: false,
    showLink: false,
    ans: ['You can avail of the following services as a free Member:-'],
    ansUlLi: [
      {
        ul: 'Create and manage your Profile on BengaliShaadi.com',
        li: [],
        anchortag: '',
      },
      { ul: 'Search and View Matches', li: [], anchortag: '' },
      { ul: 'Shortlist Members that you like', li: [], anchortag: '' },
      {
        ul:
          'Send invitations to your matches and accept invitations that you have received',
        li: [],
        anchortag: '',
      },
      {
        ul:
          'See Members who visited your Profile, Members who joined recently and Members who match your Partner Preferences.',
        li: [],
        anchortag: '',
      },
    ],
  },
  9: {
    ques:
      'My Religion/Caste/Profession is not listed as an option in the registration form. What should I do?',
    showCostWrapper: false,
    showLink: false,
    ans: [
      'BengaliShaadi.com has tried to be as comprehensive as possible while creating the many lists being used in the registration form. However, it is possible that your particular religion / caste, education, profession etc may not be represented here.',
      "In such a case we request that you use the 'Other' option provided to you. Also, you can send an email to customercare@shaadi.com clearly listing the new addition you would like us to make to the registration form. While we do not guarantee that your suggestion will be accepted, we will try our best to ensure that it does.",
    ],
    ansUlLi: [],
  },
  10: {
    ques:
      'What is the advantage of verifying my phone number? How can I do it?',
    showCostWrapper: false,
    showLink: false,
    ans: [
      'Verifying your phone number helps you get more responses, since it earns you a trust badge. The trust badge is displayed on the top right of your profile and adds authenticity to it.',
      'You can verify your phone number by using either our Interactive Voice Response System or via SMS in case you have provided a mobile number as your contact number.',
    ],
    ansUlLi: [],
  },
}

const faqCostList = [
  {
    topSellar: false,
    membershipType: 'Gold',
    months: '3 Months',
    features: [
      'Connect directly with Matches',
      'View detailed Profile information',
    ],
  },
  {
    topSellar: false,
    membershipType: 'Gold Plus',
    months: '3 Months',
    features: [
      'Connect directly with Matches',
      'View detailed Profile information',
      'Be featured under Spotlight',
      'Standout with Bold Listing',
    ],
  },
  {
    topSellar: false,
    membershipType: 'Diamond',
    months: '6 Months',
    features: [
      'Connect directly with Matches',
      'View detailed Profile information',
    ],
  },
  {
    topSellar: true,
    membershipType: 'Diamod Plus',
    months: '6 Months',
    features: [
      'Connect directly with Matches',
      'View detailed Profile information',
      'Be featured under Spotlight',
      'Standout with Bold Listing',
    ],
  },
  {
    topSellar: false,
    membershipType: 'Platinum Plus',
    months: '12 Months',
    features: [
      'Connect directly with Matches',
      'View detailed Profile information',
      'Be featured under Spotlight',
      'Standout with Bold Listing',
    ],
  },
]

export { faqListArr, faqCostList }
